<div class="dropdown-container">
  <label for="{{formControlName}}">{{label}}</label>
  <input id="{{formControlName}}" type="checkbox" [(ngModel)]="toggler">
  <div *ngIf="toggler" class="dropdown-container-list">
    <!-- <mat-chip-listbox [formControlName]="formControlName"> -->
    <mat-chip-listbox multiple [formControl]="formControl" (change)="onChange($event)" (blur)="onTouched()">
      <mat-chip-option *ngFor="let option of options" [value]="option.value">{{
        option.label }}
      </mat-chip-option>
    </mat-chip-listbox>
  </div>
  <sit-icon class="col-sm d-flex mr-1-em" [icon]="Icon.arrow_down" [sizeClass]="'icon-size-22'"
  alt="icono de parametros"
  ></sit-icon>
</div>
